import React, { useState, useEffect } from "react";
import { Hash, Loader2, Plus, Search } from "lucide-react";

const ApnInput = ({
    apn,
    onApnChange,
    onApnSubmit,
    isLoading,
    isLimitReached,
    isLoadingApn,
    analysisMode,
    primaryApn,
    planTier,
    searchLimit
}) => {
    const [inputValue, setInputValue] = useState(apn || "");

    useEffect(() => {
        setInputValue(apn || "");
    }, [apn]);

    const handleChange = (e) => {
        setInputValue(e.target.value);
        onApnChange(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (inputValue.trim() && !isLoadingApn) {
                onApnSubmit(inputValue.trim());
            }
        }
    };

    const handleSearchClick = () => {
        if (inputValue.trim() && !isLoadingApn) {
            onApnSubmit(inputValue.trim());
        }
    };

    return (
        <div className="relative">
            <label className="block text-sm font-semibold text-slate-800 mb-3">
                {analysisMode === "merged" && primaryApn ? "Add APN to Combined Lot" : "Assessor Parcel Number (APN)"}
            </label>
            <div className="relative flex items-center">
                <div className="absolute left-4 text-slate-400">
                    <Hash className="h-4 w-4" />
                </div>
                <input
                    type="text"
                    value={inputValue}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    disabled={isLoading || isLimitReached || isLoadingApn}
                    placeholder={
                        isLimitReached
                            ? `${planTier} limit reached (${searchLimit}/${searchLimit})`
                            : analysisMode === "merged" && primaryApn
                                ? "Enter another APN to combine..."
                                : "e.g., 18204019 or 336-12-045"
                    }
                    className={`w-full pl-11 pr-24 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all placeholder-slate-500 font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed ${isLimitReached ? 'bg-slate-50 text-slate-400' : 'text-slate-900'}`}
                />
                
                <div className="absolute right-2 flex items-center gap-1.5">
                    {isLoadingApn ? (
                        <div className="px-3 py-1.5 flex items-center">
                            <Loader2 className="h-4 w-4 animate-spin text-blue-600" />
                        </div>
                    ) : (
                        <button
                            type="button"
                            onClick={handleSearchClick}
                            disabled={isLoading || isLimitReached || !inputValue.trim()}
                            className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 disabled:bg-slate-100 disabled:text-slate-400 text-white font-semibold text-xs rounded-lg transition-colors flex items-center gap-1 cursor-pointer"
                        >
                            {analysisMode === "merged" && primaryApn ? (
                                <>
                                    <Plus className="h-3 w-3" />
                                    <span>Add</span>
                                </>
                            ) : (
                                <>
                                    <Search className="h-3 w-3" />
                                    <span>Find</span>
                                </>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ApnInput;
